import axios from 'axios'

/** Cookie-session API client (replaces shared Bearer password). */
export const api = axios.create({
  withCredentials: true,
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      if (
        typeof window !== 'undefined' &&
        !window.location.pathname.startsWith('/login')
      ) {
        const next = encodeURIComponent(
          window.location.pathname + window.location.search
        )
        window.location.href = `/login?next=${next}`
      }
    }
    throw error
  }
)
